import { Injectable, OnDestroy } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { withHistory } from '@sama/rxjs-core';
import { distinctUntilChanged, map } from 'rxjs';
import { IN_PROGRESS_INDEX } from '../../../../team-apis/core/reserved-shape-indexes';
import { AbstractMeshService } from '../abstract-mesh.service';
import { InProgressCuboidHelper } from './in-progress-cuboid-helper';

@Injectable()
export class InProgressCuboidService
  extends AbstractMeshService<InProgressCuboidHelper>
  implements OnDestroy
{
  constructor() {
    super();
    this.setUpSubscriptions();
  }

  private setUpSubscriptions() {
    this.subscribeTo(
      this.store('render')('inProgressArrowCuboid').$.pipe(
        map(isDefined),
        distinctUntilChanged(),
        withHistory(1),
      ),
      ([current, previous]) => {
        const shouldAddHelper = current && !previous;
        const shouldRemoveHelper = !current && previous;

        if (shouldAddHelper) {
          this.addHelper(IN_PROGRESS_INDEX, new InProgressCuboidHelper());
        } else if (shouldRemoveHelper) {
          this.removeHelper(IN_PROGRESS_INDEX);
        }
      },
    );
  }
}
